import React from 'react';
import { SwitchRoute } from '../../../Components/Route/SwitchRoute';
import {  SalesTransactionsWithAMLRoutes } from '../../../routes';

export const SalesTransactionsWithAMLLayout = () => <SwitchRoute routes={SalesTransactionsWithAMLRoutes} />;